/**
 * Child/detail routes that inherit menu access from a parent menu path.
 */
export const MENU_CHILD_ROUTE_MAP: Record<string, string> = {
  '/revenue-add-form': '/finance/revenue-add',
  '/revenue-add': '/finance/revenue-add',
  '/invoice-detail': '/finance/invoice-list',
  '/invoice-fulltax': '/finance/invoice-list',
  '/coupon-parking-list-details': '/coupon-parking-list',
  '/vehicle-card-future-detail': '/vehicle-card-future',
  '/discount-card-details': '/discount-card',
  '/stamp-discount-details': '/stamp-discount',
  '/test': '/finance/invoice-list',
};

/**
 * Routes registered via path_id map (mapper-user-menu.service.ts + app.routes.ts).
 */
export const APP_ROUTE_PATTERNS: RegExp[] = [
  /^\/access-denied$/,
  /^\/dashboard$/,
  /^\/dashboard-parking$/,
  /^\/dashboard-parking-ops$/,
  /^\/dashboard-parking-finance$/,
  /^\/parking\/transaction-parking$/,
  /^\/parking\/parking-site$/,
  /^\/parking\/parking-client$/,
  /^\/system-settings\/group-menus$/,
  /^\/system-settings\/group-sub-menus$/,
  /^\/system-settings\/menu-lists$/,
  /^\/system-settings\/manage-users$/,
  /^\/system-settings\/manage-roles$/,
  /^\/system-settings\/manage-roles-menus$/,
  /^\/system-settings\/setting-quota-card$/,
  /^\/system-settings\/setting-card-type-config$/,
  /^\/system-settings\/setting-invoice$/,
  /^\/system-settings\/setting-invoice-fee$/,
  /^\/system-settings\/approval-config$/,
  /^\/system-settings\/parking-vehicle-type$/,
  /^\/system-settings\/parking-card-type$/,
  /^\/system-settings\/parking-card-mode$/,
  /^\/system-settings\/parking-payment-log$/,
  /^\/system-settings\/activity-log$/,
  /^\/system-settings\/liff-home-menu$/,
  /^\/system-settings\/line-guide-menu$/,
  /^\/system-settings\/public-guides$/,
  /^\/system-settings\/site-public-profiles$/,
  /^\/system-settings\/line-broadcasts$/,
  /^\/system-settings\/site-free-quota$/,
  // /^\/system-settings\/user-site-access$/, // unused path_id 120 — replaced by access-groups
  /^\/system-settings\/access-groups$/,
  /^\/system-settings\/parking-gate-type$/,
  /^\/system-settings\/parking-gate$/,
  /^\/system-settings\/parking-area$/,
  /^\/system-settings\/parking-gate-group$/,
  /^\/system-settings\/parking-rate$/,
  /^\/system-settings\/ev-price-rates$/,
  /^\/system-settings\/ev-connector-types$/,
  /^\/system-settings\/line-rich-menu$/,
  /^\/card-quota\/quota-requests$/,
  /^\/card-quota\/client-quotas$/,
  /^\/card-quota\/quota-allocation$/,
  /^\/card-quota\/platform-cards$/,
  /^\/card-quota\/quota-card-advances$/,
  /^\/card-quota\/building-free-quota$/,
  /^\/card-quota\/free-parking-dashboard$/,
  /^\/card-quota\/free-parking-cards$/,
  /^\/card-quota\/free-parking-advances$/,
  /^\/cityparking\/card-advances$/,
  /^\/approval\/inbox$/,
  /^\/approval\/history$/,
  /^\/cityparking\/line-oa-member$/,
  /^\/cityparking\/register-member$/,
  /^\/cityparking\/register-member-marketing$/,
  /^\/finance\/revenue-marketing$/,
  /^\/cityparking\/customer-management$/,
  /^\/cityparking\/ev-charger-list$/,
  /^\/cityparking\/ev-station-monitor$/,
  /^\/cityparking\/ev-charging-jobs$/,
  /^\/cityparking\/news-management$/,
  /^\/cityparking\/news-categories$/,
  /^\/cityparking\/register-member-card$/,
  /^\/parking\/vehicles-in-parking$/,
  /^\/parking\/parking-cards$/,
  /^\/parking\/parking-cards-bulk-dates$/,
  /^\/parking\/parking-cards-taiwan-pending$/,
  /^\/parking\/parking-cards-deleted$/,
  /^\/parking\/membership-packages$/,
  /^\/parking\/discount\/prestamp-taiwan$/,
  /^\/parking\/discount\/taiwan-discount$/,
  /^\/parking\/discount\/stamp-group$/,
  /^\/parking\/discount\/stamp-amount-map$/,
  /^\/parking\/discount\/stamp-receipt$/,
  /^\/parking\/discount\/stamp-members$/,
  /^\/parking\/discount\/stamp-apply$/,
  /^\/parking\/discount\/stamp-billable-charge$/,
  /^\/parking\/discount\/web-stamp-history$/,
  /^\/parking\/discount\/free-range$/,
  /^\/parking\/local-fee-calc-test$/,
  /^\/system-settings\/parking-main-rate$/,
  /^\/system-settings\/parking-sub-rate$/,
  /^\/system-settings\/parking-penalty-rate$/,
  /^\/cityparking\/top-up$/,

  // Report
  /^\/report\/full-tax-report$/,
  /^\/report\/register-member-payment$/,
  /^\/report\/rpfi05$/,
  /^\/report\/rpfi09$/,
  /^\/report\/rpfi13$/,
  /^\/report\/rpfi01$/,
  /^\/report\/rpfi26$/,
  /^\/report\/rppk01$/,
  /^\/report\/rppk15$/,
  /^\/report\/rppk14$/,
  /^\/report\/rppk16$/,
  /^\/report\/rpfi15$/,
  /^\/report\/rpfi17$/,
  /^\/test$/,

  // New / Legacy Parent and Child Route Patterns
  /^\/stamp-approve$/,
  /^\/coupon-generate$/,
  /^\/register-member$/,
  /^\/vehicle-card-future$/,
  /^\/vehicle-card-future-detail(?:\/.+)?$/,
  /^\/coupon-parking-list$/,
  /^\/coupon-parking-list-details(?:\/.+)?$/,
  /^\/discount-card$/,
  /^\/discount-card-details(?:\/.+)?$/,
  /^\/discount-active$/,
  /^\/stamp-discount$/,
  /^\/stamp-discount-details(?:\/.+)?$/,
  /^\/cityparking\/vehicle-list$/,
  /^\/ev-list$/,
  /^\/parking-transaction-ev$/,
  /^\/generate-ev-qr$/,
  /^\/parking\/register-parking$/,
  /^\/provider-parking$/,
  /^\/provider-site$/,
  /^\/provider-group$/,
  /^\/provider-spot$/,
  /^\/floor-tenant-company$/,
  /^\/tenant-company$/,
  /^\/parking-type$/,
  /^\/parking-zone$/,
  /^\/finance\/invoice-list$/,
  /^\/invoice-detail(?:\/.+)?$/,
  /^\/invoice-fulltax(?:\/.+)?$/,
  /^\/fine-list$/,
  /^\/finance\/revenue-add$/,
  /^\/finance\/manage-fee$/,
  /^\/finance\/manage-fee-group$/,
  /^\/finance\/manage-subscription$/,
  /^\/finance\/parking-finance$/,
  /^\/finance\/parking-shift$/,
  /^\/finance\/bank-accounts$/,
  /^\/revenue-add$/,
  /^\/revenue-add-form$/,

  /^\/customer-service\/customer-service-issue-type$/,
  /^\/customer-service\/customer-service-case$/,
];

export function normalizeRoutePath(path: string): string {
  let normalized = path.split('?')[0].trim().toLowerCase();
  if (!normalized.startsWith('/')) {
    normalized = `/${normalized}`;
  }
  return normalized;
}

export function isKnownAppRoute(path: string): boolean {
  const normalized = normalizeRoutePath(path);
  return APP_ROUTE_PATTERNS.some((pattern) => pattern.test(normalized));
}

export function resolveMenuPath(path: string, allowedPaths: string[]): string {
  const normalized = normalizeRoutePath(path);

  if (allowedPaths.includes(normalized)) {
    return normalized;
  }

  for (const [childPrefix, parentPath] of Object.entries(MENU_CHILD_ROUTE_MAP)) {
    if (normalized === childPrefix || normalized.startsWith(`${childPrefix}/`)) {
      return parentPath;
    }
  }

  return normalized;
}
